<template>
    <div class="max-w-screen-xl mx-auto my-20 px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:flex-col sm:align-center">
            <div class="relative self-center bg-gray-100 rounded-lg p-0.5 flex sm:mt-8">
                <button type="button"
                        class="relative w-1/2 border rounded-md py-2 text-sm leading-5 font-medium text-gray-700 whitespace-no-wrap hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue focus:z-10 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150 sm:w-auto sm:px-8"
                        :class="{ 'bg-white border-gray-200  shadow-sm': sharedState.period === 'monthly', 'border-transparent': sharedState.period === 'yearly' }"
                        @click.prevent="sharedState.period = 'monthly'"
                >
                    Monthly billing
                </button>
                <button type="button"
                        class="relative w-1/2 border rounded-md py-2 text-sm leading-5 font-medium text-gray-700 whitespace-no-wrap hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue focus:z-10 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150 sm:w-auto sm:px-8"
                        :class="{ 'bg-white border-gray-200  shadow-sm': sharedState.period === 'yearly', 'border-transparent': sharedState.period === 'monthly' }"
                        @click.prevent="sharedState.period = 'yearly'"
                >
                    Yearly billing
                </button>
            </div>
        </div>
        <div class="mt-12 space-y-4 sm:mt-16 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-6 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mx-0 xl:grid-cols-3">
            <pricing-plan :plan="plan"
                          v-for="plan in plans"
                          :key="plan.id"
            ></pricing-plan>
        </div>
    </div>
</template>

<script>
    import PricingPlan from "./Plan";

	export default {
        data() {
            return {
                sharedState: {
                    period: 'monthly',
                },
            }
        },

        provide() {
            return {
                pricingPlanState: this.sharedState
            }
        },

        props: {
            plans: {
                type: Array,
                required: true
            }
        },

        components: { PricingPlan }
    }
</script>
